<div class="status-container">
  @if (showLabel) {
    <span class="status-label">{{ labelText }}</span>
  }
  <mat-icon
    [fontSet]="iconData.fontSet"
    [class]="iconData.class"
    [class.icon-sm]="size === 'small'"
    [class.icon-lg]="size === 'large'"
    [matTooltip]="showTooltip ? tooltipText : ''"
    matTooltipClass="legalization-status-tooltip"
    >
    {{ iconData.icon }}
  </mat-icon>
  @if (showStatusText) {
    <span class="status-text">{{
      element?.LegalizationStatusName || 'Legalization.Status.ReadyForLegalization' | translate
    }}</span>
  }
</div>
